import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions, LOOK_ROOM_TYPES, SIDE_POSITIONS} from "../../constants";
import {removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../../appLayout";

export default class RobeHook extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'robe_hook';
    this.partName = 'Robe Hook';
    this.translateId = "visualizer.bathroom.accessories.robe_hook";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return true
    }
    return removeLookPointFor(parentObject, 1, "1", SIDE_POSITIONS[1])
  }
}
